<template>
  <meta name="theme-color" content="#000" />

  <div
    id="app"
    :class="{ 'has-mouse': hasMouse }"
    @touchstart="hasMouse = false"
  >
    <Flipbook
      class="flipbook"
      :pages="pages"
      :pagesHiRes="pagesHiRes"
      :startPage="pageNum"
      v-slot="flipbook"
      ref="flipbook"
      @flip-left-end="onFlipLeftEnd"
      @flip-right-end="onFlipRightEnd"
    >
      <div class="header">
        <img
          :src="'./media/' + clientFolder + '/logo_white.svg'"
          :alt="'' + clientFolder + ' logo'"
        />
        <div class="page-indicator">
          <span>{{ flipbook.page }}</span
          >&nbsp;von&nbsp;<span>{{ flipbook.numPages }}</span>
        </div>
      </div>

      <div class="action-bar">
        <div
          class="btn"
          :class="{ disabled: !flipbook.canFlipLeft }"
          @click="flipbook.flipLeft"
        >
          Zurück
        </div>
        <div class="symbol-action">
          <div
            class="btn symbol"
            :class="{ disabled: !flipbook.canZoomOut }"
            @click="flipbook.zoomOut"
          >
            &#8722;
          </div>
          <div
            class="btn symbol"
            :class="{ disabled: !flipbook.canZoomIn }"
            @click="flipbook.zoomIn"
          >
            &#43;
          </div>
        </div>
        <div
          class="btn primary"
          :class="{ disabled: !flipbook.canFlipRight }"
          @click="flipbook.flipRight"
        >
          Weiter
        </div>
      </div>
    </Flipbook>
  </div>
</template>

<script>
import Flipbook from "flipbook-vue";

const clientProps = [
  {
    id: "sportscheck",
    folder: "sportscheck",
    title: "SportScheck Team-Leitfaden",
    description: "Entdecke den SportScheck Team-Leitfaden",
    brandColor: "#F85C39",
    pages: 24,
  },
  {
    id: "voswinkel",
    folder: "voswinkel",
    title: "Voswinkel Team-Leitfaden",
    description: "Entdecke den Voswinkel Team-Leitfaden",
    brandColor: "#134182",
    pages: 24,
  },
];

const loc = window.location.hostname;
const client = clientProps.find((client) => loc.includes(client.id));

export default {
  components: { Flipbook },
  data() {
    return {
      pages: [],
      pagesHiRes: [],
      hasMouse: true,
      pageNum: null,
      clientFolder: client.folder,
      fullscreenState: false,
    };
  },
  methods: {
    onFlipLeftEnd(page) {
      window.location.hash = "#" + page;
    },
    onFlipRightEnd(page) {
      window.location.hash = "#" + page;
    },
    setPageFromHash() {
      const n = parseInt(window.location.hash.slice(1), 10);
      if (isFinite(n)) this.pageNum = n;
    },
  },
  mounted() {
    const containerDiv = document.getElementById("app");
    containerDiv?.style.setProperty("--brand-color", client.brandColor);

    document
      .querySelector('meta[name="theme-color"]')
      .setAttribute("content", client.brandColor);

    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", client.description);

    const favicon = document.createElement("link");
    favicon.rel = "icon";
    favicon.href = "./media/" + client.folder + "/favicon.png";
    document.head.appendChild(favicon);

    function generatePagesArray(client, folder, length) {
      const pages = [null]; // first page is nul
      for (let i = 1; i <= length; i++) {
        pages.push(`media/${client}/${folder}/${i}.jpg`);
      }
      return pages;
    }

    // Simulate asynchronous pages initialization
    setTimeout(() => {
      this.pages = generatePagesArray(
        client.folder,
        "pages_large",
        client.pages
      );
      this.pagesHiRes = generatePagesArray(
        client.folder,
        "pages_large",
        client.pages
      );
    }, 1);

    window.addEventListener("hashchange", this.setPageFromHash);
    this.setPageFromHash();
  },
};
</script>

<style>
@font-face {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 500;
  display: swap;
  src: url("../public/fonts/montserrat-500.woff2") format("woff2");
}
@font-face {
  font-family: "opensans";
  font-style: normal;
  display: swap;
  src: url("../public/fonts/open-sans-regular.woff2") format("woff2");
}
@font-face {
  font-family: "opensans";
  font-style: bold;
  display: swap;
  src: url("../public/fonts/open-sans-500.woff2") format("woff2");
}

:root {
  --brand-shadow: 0 12px 48px 0 rgba(0, 0, 0, 0.15),
    0 6px 16px 0 rgba(0, 0, 0, 0.15), 0 0 6px -2px rgba(0, 0, 0, 0.2);
  --color-button-body: #f5f5f5;
  --color-body: #000;
  --color-background-neutral: #eaeaea;
  --color-background: #f5f5f5;
  --site-padding: clamp(16px, 1.5vw, 32px);
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app {
  font-family: "opensans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--brand-color);
  color: var(--color-body);
  overflow: hidden;
}

a {
  color: inherit;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: var(--site-padding);
  z-index: 1;
  img {
    width: 192px;
    max-width: 40vw;
    height: auto;
    @media (orientation: landscape) and (hover: none) and (pointer: coarse) {
      max-width: 160px;
    }
  }
  .page-indicator {
    display: block;
    align-self: start;
    font-size: 12.5px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 100px;
    padding: 6px 20px;
    color: rgba(255, 255, 255, 0.7);
    span {
      font-weight: bold;
      color: #fff;
      letter-spacing: 0.05em;
    }
  }
}

.action-bar {
  position: fixed;
  left: 0;
  bottom: 0;
  padding: var(--site-padding);
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  gap: 4px;
  @media (min-width: 768px) {
    gap: 32px;
    justify-content: center;
  }
  .symbol-action {
    display: flex;
    gap: 6px;
  }
  .btn {
    font-size: 14px;
    color: #fff;
    /* background-color: var(--brand-color); */
    border: 1px solid rgba(255, 255, 255, 0.6);
    border-radius: 100px;
    height: 44px;
    padding: 0 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    /* letter-spacing: -0.03em; */
    &.primary {
      background-color: #fff;
      color: var(--brand-color);
      /* font-weight: bold; */
    }
    &.symbol {
      width: 44px;
      padding: 0;
      font-weight: 600;
      /* border-color: #fff; */
    }
    &:hover {
      cursor: pointer;
      opacity: 0.85;
    }
    &:active {
      opacity: 0.85;
    }
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
      border: 1px solid rgba(255, 255, 255, 0.4);
    }
  }
}
.flipbook {
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.flipbook .viewport {
  margin-top: 72px;
  width: calc(100vw - var(--site-padding) * 2) !important;
  height: calc(100vh - 200px) !important;
  max-width: 90vw;
  @media (max-width: 768px) {
    margin-top: 56px;
    max-width: 100vw;
  }
  @media (orientation: landscape) and (hover: none) and (pointer: coarse) {
    margin-top: 56px;
    width: calc(100vw - var(--site-padding) * 2) !important;
    height: calc(100vh - 56px - 72px) !important;
  }
  .bounding-box {
    box-shadow: var(--brand-shadow);
  }
}
</style>
